import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @augments {Base<ComponentProps>}
 */
export default class InternalClick extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'InternalClick',
  };

  /**
   * Click on link
   * @param {object} props Props
   * @param {object} props.target current element
   * @returns {void}
   */
  onClick({ target }) {
    window.dataLayer.push({
      event: 'click',
      linkText: target.title ? target.title : target.textContent,
      linkUrl: target.href,
      current_destination: window.cs_datalayer.current_destination,
      pageUrl: window.location.href,
      page_type: window.cs_datalayer.page_type,
      page_title: window.cs_datalayer.page_title,
      referrer: document.referrer,
    });
  }
}
